import type { Control, FieldValues } from 'react-hook-form';
import { isCheckboxChangeEventType } from '../../dynamic-form/dynamic-form-common';
import OdinController from '../../dynamic-form/odin-controller.component';
import type { CheckboxProps } from './checkbox';
import { Checkbox } from './checkbox';

export interface HfCheckboxProps<TFieldValues extends FieldValues = FieldValues> extends CheckboxProps {
  control: Control<TFieldValues>;
  name: string;
}

export const HfCheckbox = <TFieldValues extends FieldValues = FieldValues>({
  control,
  label,
  name,
  value,
  description,
  readOnly,
  required,
  onChange,
  fieldValueConverter,
  disabled,
  labelStyles,
}: HfCheckboxProps<TFieldValues>) => {
  return (
    <OdinController
      name={name}
      control={control}
      onChange={onChange}
      fieldValueConverter={fieldValueConverter}
      render={({ field: { onChange, value: fieldValue }, fieldState: { error } }) => {
        let checkedValue = false;
        if (typeof fieldValue === 'boolean') {
          checkedValue = fieldValue;
        } else if (isCheckboxChangeEventType(fieldValue)) {
          checkedValue = fieldValue.checked;
        }

        return (
          <Checkbox
            name={name}
            label={label}
            value={value}
            description={description}
            checked={checkedValue}
            onChange={onChange}
            readOnly={readOnly}
            required={required}
            error={error?.message}
            disabled={disabled}
            labelStyles={labelStyles}
          />
        );
      }}
    />
  );
};
